module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_7016.42303005.png";